import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { EventStatus } from '@/types';
import { useTranslation } from 'react-i18next';

const STATUS_COLORS: Record<EventStatus, string> = {
  [EventStatus.Initial]: 'bg-gray-100 text-gray-700 hover:bg-gray-100',
  [EventStatus.Rejected]: 'bg-red-100 text-red-700 hover:bg-red-100',
  [EventStatus.InReview]: 'bg-amber-100 text-amber-800 hover:bg-amber-100',
  [EventStatus.Approved]: 'bg-green-100 text-green-800 hover:bg-green-100',
  [EventStatus.Online]: 'bg-emerald-100 text-emerald-800 hover:bg-emerald-100',
  [EventStatus.Completed]: 'bg-blue-100 text-blue-800 hover:bg-blue-100',
  [EventStatus.Cancelled]: 'bg-red-100 text-red-800 hover:bg-red-100',
};

export function StatusBadge({ status }: { status: EventStatus }) {
  const { t } = useTranslation('events');
  return (
    <Badge className={cn(STATUS_COLORS[status], 'whitespace-nowrap font-medium')}>
      {t(`status.${status}`)}
    </Badge>
  );
}
